// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2E3NT","inner":"Form_inner__2EW21","range":"Form_range__2U4Us","name":"Form_name__1RPHb","actions":"Form_actions__j2SU2"};